"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgCheck = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M21.09 3.486L8.567 16.045l-5.657-5.672c-.646-.648-1.778-.648-2.424 0-.647.648-.647 1.783 0 2.43l6.869 6.888c.323.324.808.486 1.212.486.404 0 .889-.162 1.212-.486L23.515 5.917c.647-.648.647-1.783 0-2.43-.727-.649-1.778-.649-2.424 0z" })));
};
exports.default = SvgCheck;
//# sourceMappingURL=Check.js.map